import {VehicleSeriesDefinitionFormProps} from '../types';
import {VehicleSeriesDefinitionContextProvider} from './VehicleSeriesDefinitionContextProvider';
import {VehicleSeriesDefinitionFormWrapper} from './VehicleSeriesDefinitionFormWrapper';

export const VehicleSeriesDefinitionForm = ({
  vehicleTypes,
  seriesList,
  branchList,
  isSystem,
  ...rest
}: VehicleSeriesDefinitionFormProps) => (
  <VehicleSeriesDefinitionContextProvider
    branchList={branchList}
    seriesList={seriesList}
    vehicleTypes={vehicleTypes}
    isSystem={isSystem}
  >
    <VehicleSeriesDefinitionFormWrapper {...rest} />
  </VehicleSeriesDefinitionContextProvider>
);
